import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";
import { BlogEntryPreview } from "../custom_schema_view/BlogEntryPreview";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const communitySchema = buildSchema({
    name: "Community entry",
    views: [{
        path: "preview",
        name: "Preview",
        builder: (props) => <BlogEntryPreview {...props} />
    }],
    properties: {
        description: buildProperty({
            title: "Description",
            dataType: "string",
            disabled: true,
        }),
        isDeleted: buildProperty({
            title: "Is Deleted",
            dataType: "boolean",
            disabled: true,
        }),
        commentsCount: buildProperty({
            title: "Comments Count",
            dataType: "number",
            disabled: true,
        }),
        likeCount: buildProperty({
            title: "Like Count",
            dataType: "number",
            disabled: true,
        }),
        repliesCount: buildProperty({
            title: "Replies Count",
            dataType: "number",
            disabled: true,
        }),
        createdAt: buildProperty({
            title: "Created At",
            dataType: "timestamp",
            disabled: true,
        }),
        media: buildProperty({
            title: "Media",
            description: "Example of a complex array with multiple properties as children",
            validation: { required: true },
            dataType: "array",
            columnWidth: 400,
            of: {
                dataType: "map",
                properties: {
                    url: {
                        title: "Url",
                        dataType: "string",
                        config: {
                            storageMeta: {
                                mediaType: "image",
                                storagePath: `community_storage/${new Date().toLocaleDateString('en-CA')}/${new Date().getTime()}`,
                                acceptedFiles: ["community_storage/*"],
                                storeUrl: true,
                                metadata: {
                                    cacheControl: "max-age=1000000"
                                },
                                fileName: (context) => {
                                    return Math.random()  + "-" + context.file.name;
                                }
                            }
                        }
                    }
                }
            },
            disabled: true
        }),
        isPublished: buildProperty({
            title: "Is Published",
            dataType: "boolean",
        }),
        
    },
    defaultValues: {
        status: "draft",
        order: 0
    }
});

export const commentSchema = buildSchema({
    name: "Comments",
    views: [{
        path: "preview",
        name: "Preview",
        builder: (props) => <BlogEntryPreview {...props} />
    }],
    properties: {
        comment: buildProperty({
            title: "Comment",
            dataType: "string",
            disabled: true,
        }),
        commentsCount: buildProperty({
            title: "Comments Count",
            dataType: "number",
            disabled: true,
        }),
        createdAt: buildProperty({
            title: "Created At",
            dataType: "timestamp",
            disabled: true,
        }),
        isDeleted: buildProperty({
            title: "Is Deleted",
            dataType: "boolean",
            disabled: true,
        }),
        likeCount: buildProperty({
            title: "Like Count",
            dataType: "number",
            disabled: true,
        }),
        reactionCount: buildProperty({
            title: "Reaction Count",
            dataType: "number",
            disabled: true,
        }),
        isPublished: buildProperty({
            title: "Is Published",
            dataType: "boolean",
        }),
        
    },
    defaultValues: {
        status: "draft",
        order: 0
    }
});

export const replySchema = buildSchema({
    name: "Reply",
    views: [{
        path: "preview",
        name: "Preview",
        builder: (props) => <BlogEntryPreview {...props} />
    }],
    properties: {
        comment: buildProperty({
            title: "Comment",
            dataType: "string",
            disabled: true,
        }),
        commentsCount: buildProperty({
            title: "Comments Count",
            dataType: "number",
            disabled: true,
        }),
        likeCount: buildProperty({
            title: "Like Count",
            dataType: "number",
            disabled: true,
        }),
        createdAt: buildProperty({
            title: "Created At",
            dataType: "timestamp",
            disabled: true,
        }),
        isDeleted: buildProperty({
            title: "Is Deleted",
            dataType: "boolean",
            disabled: true,
        }),
        reactionCount: buildProperty({
            title: "Reaction Count",
            dataType: "number",
            disabled: true,
        }),
        isPublished: buildProperty({
            title: "Is Published",
            dataType: "boolean",
        }),
        
    },
    defaultValues: {
        status: "draft",
        order: 0
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};
